import { css } from '@emotion/react';

import { COLOR_PALETTE, Flex, Text } from '@inflearn/ds-react-next';

import { useWebviewThemeParameter } from '../../../lib/useThemeParamter';

interface SocialLoginDividerProps {
  children: string;
}

const SocialLoginDivider = ({ children }: SocialLoginDividerProps) => {
  const { isDarkTheme } = useWebviewThemeParameter();

  return (
    <Flex
      direction="row"
      justify="center"
      align="center"
      gap={6}
      styles={{
        root: {
          ...styleDivider,
          ...(isDarkTheme ? darkThemeStyle.line : {}),
        },
      }}
    >
      <Text
        size="xs"
        c={isDarkTheme ? darkThemeStyle.text.color : 'gray.5'}
        styles={{
          root: { flex: '0 0 80px', textAlign: 'center' },
        }}
      >
        {children}
      </Text>
    </Flex>
  );
};

const styleDivider = css({
  width: '100%',
  '&::before, &::after': {
    flex: '1 1 100%',
    content: '""',
    display: 'block',
    height: '1px',
    backgroundColor: COLOR_PALETTE.gray[2],
  },
});

export const darkThemeStyle = {
  line: {
    '&::before, &::after': { backgroundColor: COLOR_PALETTE.dark[5] },
  },
  text: {
    color: 'dark.2',
  },
};

export default SocialLoginDivider;
